module.exports = __webpack_public_path__ + "img/sublime-save-as.25f98736.jpg";